import React from "react";
import { connect } from "react-redux";
import AddIcon from "../UIComponents/AddIcon";
import { searchsettingsMgmt } from "../Actions/ShippingSettings";
import ShippingSettingsCard from "./ShippingSettingsCard";
import { getShipnameList } from "../Actions/HelpersAPI";
import Autocomplete from "react-autocomplete";
import Role from "../helpers/role";

const SearchItem = {
  shipId: 0,
  ShipName: "",
  toMail: "",
  ccMail: "",
  PageNumber: 1,
  PageSize: 25,
};
let userRole = localStorage.getItem("UserRoles");

class ShippingSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        shipId: 0,
        shipName: "",
        toMail: "",
        ccMail: "",
        PageNumber: 1,
        PageSize: 25,
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.SearchData = this.SearchData.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    if (match?.params?.id) {
      this.state.searchData.settingsId = match.params.id;
    }
    dispatch({ type: "SubBannerTitle", data: "Settings" });
    dispatch(searchsettingsMgmt(this.state.searchData, 1));
    dispatch(getShipnameList());
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }

  SearchData(Pgno) {
    this.state.searchData.PageNumber = Pgno;
    this.props.dispatch(searchsettingsMgmt(this.state.searchData, Pgno));
  }

  ClearInput() {
    this.state.searchData.shipId = 0;
    this.state.searchData.shipName = "";
    this.state.searchData.toMail = "";
    this.state.searchData.ccMail = "";
    this.props.dispatch(searchsettingsMgmt(this.state.searchData, 1));
  }
  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }
  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    this.state.searchData[field] = value;
    this.state.searchData[fieldId] = id;
    this.setState({});
  };
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { ShipNameList, showSidePane, showShipName, SearchSettings } =
      this.props;

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue "
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', marginTop: '-1.5px' }}>&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className=" card MM-card-header mb-0"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="card-body flex"
                    style={{
                      padding: "0rem",
                      backgroundColor: "#1a3464",
                      color: "white",
                    }}
                  >
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      Settings
                    </h5>
                    {userRole == Role.mmpl ? (<></>) : (<>
                      <div
                        className="m-1 flex"
                        onClick={() => this.AddKeyword()}
                      >
                        <span className="m-auto small-title">
                          Add Settings
                        </span>
                        <AddIcon />
                      </div>
                    </>
                    )}
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row pb-3">
                    <div
                      className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                    >
                      <div
                        className="autocomplete-wrappers"
                        style={{
                          zIndex: showShipName ? 0 : null,
                        }}
                      >
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        <Autocomplete
                          contentEditable={true}
                          value={this.state.searchData.shipName}
                          inputProps={{
                            placeholder: "Ship Name",
                          }}
                          items={ShipNameList ?? []}
                          getItemValue={(item) => item.shipName}
                          shouldItemRender={this.renderShipNameTitle.bind(
                            this
                          )}
                          renderMenu={(item) => (
                            <div className="dropdown">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${isHighlighted ? "selected-items" : ""
                                }`}
                            >
                              {item.shipName}
                            </div>
                          )}
                          onChange={(e) => this.handleAnnualSearchChange(e)}
                          onSelect={(value, item) =>
                            this.handleAnnualSelectChange(
                              value,
                              "shipName",
                              item.shipID,
                              "shipId"
                            )
                          }
                        />
                      </div>
                    </div>
                    <div
                      className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                    >
                      <label className="form-label">To Email</label>
                      <br></br>
                      <input
                        className="form-control"
                        name="toMail"
                        placeholder="To Email"
                        value={this.state.searchData.toMail}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    <div
                      className={showSidePane ? "col-lg-6 " : "col-lg-4 "}
                    >
                      <label className="form-label">Cc Email</label>
                      <br></br>
                      <input
                        className="form-control"
                        name="ccMail"
                        placeholder="Cc Email"
                        value={this.state.searchData.ccMail}
                        onChange={(e) => this.handleInputChange(e)}
                      ></input>
                    </div>
                    <div
                      className={showSidePane ? "col-lg-6" : "col-lg-12"}
                    >
                      <label className="mt-4"></label>
                      <br></br>
                      <div
                        className="search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.SearchData(1)}
                        >
                          {" "}
                          Search{" "}
                        </button>

                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.ClearInput()}
                        >
                          {" "}
                          Clear{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {SearchSettings ? (
            <ShippingSettingsCard
              arraylist={SearchSettings.data}
              pageSize={SearchSettings.pagination.pageSize}
              currentPage={SearchSettings.pagination.currentPage}
              totalRecords={
                SearchSettings.pagination.totalcount
                  ? SearchSettings.pagination.totalcount
                  : 0
              }
              setUpdatedState={(value) => this.SearchData(value)}
            />
          ) : null}
        </div>
      </div>
    );
  }

  AddKeyword = () => {
    const { dispatch, history } = this.props;
    history.push(`/Home/AddSettings`);
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    showShipName: state.SidePanReducer.shipName || false,
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    SearchSettings: state.ShippingSettingsReducer.SearchSettings,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ShippingSettings);
